module.exports = __webpack_public_path__ + "media/images/default/homepage/experience/experience05-e5b26664a6d056056c3267b73b56f158.svg";